export const tableCacheKeys = {
  CLUSTERS_TABLE: 'clusters-table',
  PLATFORM_USAGE: {
    ENTITIES: 'platform-usage-entities-table',
    DAILY: 'platform-usage-daily-table',
    DATABASE_INSTANCES: 'platform-usage-database-instances-table',
  },
  CLUSTERS_TABLE_OP: 'clusters-table-op-v2',
  NOT_FOUND_CLUSTERS: 'not-found-clusters-table',
  ACCESS_KEYS: 'access-keys-table',
  BILLING_REPORT: {
    PER_CLUSTER: 'billing-report-per-cluster-table',
    DAILY: 'billing-report-daily-table',
  },
  ENTERPRISE_BILLING_REPORT: {
    PER_ORGANIZATION: 'enterprise-billing-report-per-organization-table',
    DAILY: 'enterprise-billing-report-daily-table',
  },
  SSO_CONNECTIONS: 'sso-connections-table',
  SCHEDULED_REBALANCING: {
    MAIN: 'scheduled-rebalancing',
    CLUSTERS: 'clusters',
  },
  CLUSTER_HIBERNATION: {
    MAIN: 'cluster-hibernation',
    CLUSTERS: 'clusters',
    SCHEDULES: 'schedules',
  },
  COST_MONITORING: {
    ORGANIZATION: {
      IDLE_RESOURCES: {
        DISKS: 'organization-compute-cost-idle-disks-table',
      },
      NODE_TEMPLATES: 'node-templates-table',
      CLUSTERS: {
        COMPUTE_COST: 'organization-compute-cost-clusters-table',
        RESOURCE_EFFICIENCY: 'clusters-resource-efficiency-by-cluster-table',
        STORAGE_EFFICIENCY: 'clusters-storage-efficiency-by-cluster-table',
      },
    },
    CLUSTER: {
      DAILY_COMPUTE_SPEND: 'cluster-daily-compute-spend-details',
      NETWORK_DETAILS: 'daily-network-details-table',
      RESOURCE_EFFICIENCY: 'resource-efficiency-details',
      STORAGE_EFFICIENCY: 'storage-efficiency-details',
      CLM_RECENT_MIGRATIONS: 'clm-recent-migrations-table',
      CLM_TIMELINE: 'clm-migration-timeline-table',
      CLM_WORKLOADS: 'clm-workloads-table',
      CLM_INCOMPATIBLE_WORKLOADS: 'clm-incompatible-workloads-table',
      RELIABILITY: 'cluster-reliability-daily-details',
    },
    WORKLOADS: {
      COMPUTE_COST: 'workloads-compute-cost-table',
      RELIABILITY: 'workloads-reliability-table',
      NETWORK_COST: 'workloads-network-cost-table',
      EFFICIENCY: 'workloads-efficiency-table',
      GPU_UTILIZATION: 'workloads-gpu-utilization-summary-table',
      DETAILS: {
        COMPUTE_SPEND: 'workload-details-compute-spend',
      },
    },
    WORKLOAD: {
      DETAILS: {
        RELIABILITY: 'workload-details-reliability',
      },
      GPU_UTILIZATION: 'workload-gpu-utilization-summary-table',
    },
    NAMESPACES: {
      LIST: 'namespaces-compute-cost-table',
      WORKLOADS_DRAWER: 'namespace-compute-cost-workloads-drawer-table',
      NETWORK_COST: 'namespaces-network-cost-table',
      NETWORK_COST_WORKLOADS_DRAWER: 'workload-network-details-drawer-table',
      COMPUTE_COST_DETAILS: 'namespace-compute-cost-details-table',
      COMPUTE_COST_DETAILS_WORKLOADS_DRAWER:
        'allocation-group-workloads-drawer-table',
    },
    ALLOCATION_GROUPS: {
      COMPUTE_COST: 'allocation-groups-table',
      NETWORK_COST: 'allocation-groups-network-cost-table',
      NETWORK_COST_WORKLOADS_DRAWER: 'workload-network-details-drawer-table',
      EFFICIENCY: 'allocation-groups-efficiency-table',
      EFFICIENCY_WORKLOADS_DRAWER:
        'allocation-group-workloads-efficiency-table',
    },
    ALLOCATION_GROUP: {
      COMPUTE_COST: 'allocation-group-compute-cost-table',
    },
  },
  COMMITMENTS: {
    LIST: 'commitments-table',
  },
  SECURITY: {
    CHECKS: 'security-insights-compliance-checks-table',
    WORKLOAD_CHECKS: 'workload-security-insights-checks-table',
    IMAGES: 'security-insights-vulnerability-management-images-table',
    WORKLOAD_IMAGES: 'workload-security-insights-images-table',
    AFFECTED_RESOURCES:
      'security-insights-vulnerability-management-affected-resources-table',
    ATTACK_PATH: 'attack-path-table',
    WORKLOAD_ATTACK_PATH: 'workload-attack-path-table',
    ANOMALIES: 'anomalies-table',
    WORKLOAD_ANOMALIES: 'workload-anomalies-table',
    ANOMALY_EVENTS: 'anomaly-events-table',
    RUNTIME_EVENTS: 'runtime-events-table',
    NODE_UPDATES: 'security-insights-node-updates-nodes-table',
    ATTACK_PATH_IMAGE_VULNERABILITIES:
      'security-insights-attack-path-image-vulnerabilities-table',
    RESOURCE_CHECKS: 'security-insights-resource-checks-table',
    COMPLIANCE_RESOURCES: 'security-insights-compliance-resources-table',
    COMPLIANCE_EXCEPTIONS:
      'security-insights-compliance-exceptions-drawer-resources-table',
    RUNTIME_RULES: 'runtime-rules-table',
    CUSTOM_DENY_LISTS: 'custom-deny-lists-table',
  },
  CLUSTER: {
    RESTRICTIONS: 'cluster-restrictions-table',
  },
  CLUSTER_DASHBOARD: {
    UNSCHEDULED_WORKLOADS: 'cluster-unscheduled-workloads-table',
    WORKLOADS_GPU_UTILIZATION: 'workloads-gpu-utilization-table',
  },
  SAVINGS: {
    SPOT_INSTANCES_DRAWER: 'available-savings-workloads-drawer-table',
    WORKLOADS_RIGHTSIZING_DRAWER: 'workloads-rightsizing-savings-drawer-table',
    WORKLOADS_RIGHTSIZING_AUTOSCALER_DRAWER:
      'savings-workloads-rightsizing-autoscaler-drawer-table',
    DAILY_SAVINGS_DETAILS: 'daily-savings-details',
  },
  WORKLOAD_OPTIMIZATION: {
    WORKLOADS_LIST: 'workload-optimization-table',
    SCALING_POLICIES: 'scaling-policies-table',
    IMPACT_WORKLOADS_LIST: 'impact-workloads-table',
    HPA_LIST: 'hpa-list-table',
  },
  NODES: {
    LIST: 'node-list-table',
    WORKLOADS: 'node-workloads-table',
    NODE_DETAILS_WORKLOADS: 'node-details-workloads-table',
  },
  NODE_SELECTION_TEMPLATES: 'node-selection-templates-table',
  NODE_CONFIG_TEMPLATES: 'node-configurations-table',
  POD_MUTATIONS: 'pod-mutations-table',
  POD_MUTATIONS_AFFECTED_WORKLOADS: 'pod-mutations-affected-workloads-table',
  POD_MUTATIONS_UNAFFECTED_WORKLOADS:
    'pod-mutations-unaffected-workloads-table',
  EDGE_LOCATIONS: 'edge-locations-table',
  EDGE_CONFIGURATIONS: 'edge-configurations-table-v4',
  OMNI_AVAILABLE_INSTANCES: 'omni-available-instances-table',
  REBALANCING: {
    LOG: 'rebalancer-history-table',
    SCHEDULES: 'rebalancer-cluster-schedules-table',
    KENT_SCHEDULES: 'kent-cluster-schedules-table',
    AFFECTED_NODES: 'rebalancer-affected-nodes-table',
    SELECT_WORKLOADS: 'rebalancer-wizard-select-workloads-table',
    SELECT_NODES: 'rebalancer-wizard-select-nodes-table',
    WORKLOADS_IN_NODE: 'rebalancer-wizard-workloads-in-node-table',
    PLAN_CONFIGURATION_NODES: 'rebalancer-plan-configuration-nodes-table',
  },
  AUDIT: {
    UNSCHEDULED_PODS: 'audit-unscheduled-pods-table',
    ORG_EVENTS: 'org-audit-events-table',
  },
  LLM: {
    SAVINGS_BY_CATEGORY: 'api-key-savings-by-category-table',
    OPTIMIZATION_BY_API_KEY: 'llm-optimization-by-api-keys-table',
    SAVINGS_BY_API_KEY: 'category-savings-by-api-key',
    OPTIMIZATION_BY_CATEGORY: 'llm-optimization-by-category-table',
    PROVIDERS: 'llm-providers-table',
    BATCH_JOBS: 'llm-batch-jobs-table',
  },
  NOTIFICATIONS: 'notifications-table',
  ORGANIZATION: {
    USERS: 'organization-users-table',
    USER_GROUPS: 'organization-user-groups-table',
    ROLE_BINDINGS: 'organization-role-bindings-table',
  },
  CLOUD_ASSET_INTEGRATIONS: 'cloud-asset-integrations',
  ENTERPRISE: {
    USERS: 'enterprise-users-table',
  },
  DBO: {
    DB_COMPONENTS: 'dbo-db-components-table',
    LOGICAL_DATABASES: 'dbo-logical-databases-table',
    LOGICAL_DATABASES_WITH_DB_QUERIES:
      'dbo-logical-databases-with-db-queries-table',
    CACHE_QUERIES: 'dbo-cache-queries-table',
    CACHE_QUERIES_V2: 'dbo-cache-queries-v2-table',
    CACHES: 'dbo-caches-table',
    CLUSTER_INSTANCES: 'dbo-cluster-instances-table',
    PERFORMANCE_ADVISOR_CACHE_GROUPS:
      'dbo-performance-advisor-cache-groups-table',
    PERFORMANCE_ADVISOR_DATABASES: 'dbo-performance-advisor-databases-table',
    PERFORMANCE_ADVISOR_RECOMMENDATIONS:
      'dbo-performance-advisor-recommendations-table',
  },
  OBSERVABILITY: {
    NETFLOW: 'netflow-table',
    NETWORK_FLOWS: 'network-flows-table',
  },
  DISCOUNTS: 'discounts',
  CLUSTER_AUTOSCALER_CONFIG: 'cluster-autoscaler-config-table',
  KENT: {
    NODE_POOLS: 'kent-node-pools-table',
    NODE_CLASSES: 'kent-node-classes-table',
    NODE_OVERLAYS: 'kent-node-overlays-table',
  },
  APA: {
    CLUSTERS_INTEGRATIONS_TABLE: 'apa-clusters-integrations-table',
    PROVIDERS_INTEGRATIONS_TABLE: 'apa-providers-integrations-table',
    CREDENTIALS_TABLE: 'apa-credentials-table',
    FIX_IMAGE_VULN_RUNBOOK: 'apa-fix-image-vuln-runbook-table',
    DBO_RUNBOOK: 'apa-dbo-runbook-table',
    WOOP_RUNBOOK: 'apa-woop-runbook-table',
    COMPLIANCE_RUNBOOK: 'apa-compliance-runbook-table',
    RUN_EVENTS: 'apa-run-events-table',
  },
  SPOT_INTERRUPTIONS: {
    NODE_TEMPLATES: 'spot-interruptions-node-templates-table',
  },
  CLOUD_VMS: {
    INSTANCES: 'cloud-vms-instances-table',
  },
  STORAGE_OPTIMIZATION: {
    PERSISTENT_VOLUMES: 'storage-optimization-persistent-volumes-table',
    PV_POLICIES: 'storage-optimization-pv-policies-table',
  },
};
